import { Pathway } from '@doc-abode/data-models';
import { findByValue } from '../common/findByValue';
import { getFriendlyLabel, getFriendlyLabelFromArray } from '../common/getFriendlyLabel';

export function findPathway(pathwayToFind?: string, pathways?: Pathway[]): Pathway | undefined {
    return findByValue(pathwayToFind, pathways) as Pathway | undefined;
}

export function getFriendlyPathwayLabelFromPathway(
    pathway?: Pathway,
    textIfNotFound?: string,
): string {
    return getFriendlyLabel(pathway, textIfNotFound);
}

export function getFriendlyPathwayLabel(
    pathwayToFind?: string,
    pathways?: Pathway[],
    textIfNotFound?: string,
): string {
    return getFriendlyLabelFromArray(pathwayToFind, pathways, textIfNotFound);
}
